export var sleep = function (ms) { return new Promise(function (r) { return setTimeout(r, ms); }); };
